import React, { useState, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Select from 'components/form/Select';
import CheckboxGroup from 'components/form/CheckboxGroup';
import RadioGroup from 'components/form/Radio';
import RangeInput from 'components/form/Range';
import Button from 'components/common/Button';
import states from 'constant/states';
import debounce from 'lodash/debounce';

const Sizes = [
  { label: 'Small', value: '1..2000' },
  { label: 'Medium', value: '2000..15000' },
  { label: 'Large', value: '15001..' },
];

const initialFilters = {
  ['state']: [],
  ['latest.completion.consumer_rate__range']: [0, 1],
  ['latest.cost.avg_net_price.overall__range']: [0, 100000],
  ['latest.admissions.admission_rate.overall__range']: [0, 1],
  ['latest.admissions.sat_scores.midpoint.math__range']: [0, 800],
  ['latest.admissions.sat_scores.midpoint.critical_reading__range']: [0, 800],
  ['latest.admissions.act_scores.midpoint.cumulative__range']: [0, 36],
  ['latest.student.size__range']: '',
};

const Filters = ({ onApplyFilter }) => {
  const [filters, setFilters] = useState({
    ...initialFilters,
  });

  useEffect(() => {
    debouncedSearch(filters);
  }, [filters]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const buildQuery = (params) => {
    const query = Object.keys(params).reduce((acc, key) => {
      let value = params[key];
      if (Array.isArray(value)) {
        if (key === 'school.state') {
          value = value.map((i) => i.value).join(',');
        }  else {
          value = value.join('..');
        }
      }
      if (!value) return acc;
      return {
        ...acc,
        [key]: value,
      };
    }, {});
    return query;
  };

  const debouncedSearch = debounce((q) => {
    onApplyFilter(buildQuery(q));
  }, 1000);

  const onReset = () => {
    setFilters({
      ...initialFilters,
    });
  };

  return (
    <Paper>
      <Box p={2}>
        <Typography paragraph variant="body2">
          Filter by
        </Typography>

        <Select
          isMulti
          allowClear
          size="small"
          options={states}
          label="Location"
          value={filters['school.state']}
          onChange={(val) =>
            setFilters({
              ...filters,
              ['school.state']: val,
            })
          }
        />
        <RangeInput
          label="Graduation Rate"
          name="latest.completion.consumer_rate__range"
          value={filters['latest.completion.consumer_rate__range']}
          onChange={onChange}
          valueLabelFormat={(val) => `${(val * 100).toFixed(0)}%`}
          step={0.01}
          max={1}
        />
        <RangeInput
          label="Average Annual Cost"
          name="latest.cost.avg_net_price.overall__range"
          value={filters['latest.cost.avg_net_price.overall__range']}
          onChange={onChange}
          valueLabelFormat={(val) => `$${val/1000}k`}
          max={100000}
          step={1000}
        />
        <RangeInput
          label="Acceptance Rate"
          name="latest.admissions.admission_rate.overall__range"
          value={filters['latest.admissions.admission_rate.overall__range']}
          onChange={onChange}
          valueLabelFormat={(val) => `${(val * 100).toFixed(0)}%`}
          step={0.01}
          max={1}
        />
        <RangeInput
          label="SAT Math"
          name="latest.admissions.sat_scores.midpoint.math__range"
          value={filters['latest.admissions.sat_scores.midpoint.math__range']}
          onChange={onChange}
          max={800}
        />
        <RangeInput
          label="SAT Critical Reading"
          name="latest.admissions.sat_scores.midpoint.critical_reading__range"
          value={
            filters[
              'latest.admissions.sat_scores.midpoint.critical_reading__range'
            ]
          }
          onChange={onChange}
          max={800}
        />
        <RangeInput
          label="ACT Score"
          name="latest.admissions.act_scores.midpoint.cumulative__range"
          value={
            filters['latest.admissions.act_scores.midpoint.cumulative__range']
          }
          onChange={onChange}
          max={36}
        />
        <RadioGroup
          size="small"
          label="Size"
          options={Sizes}
          onChange={(e) =>
            setFilters({ ...filters, ['latest.student.size__range']: e.target.value })
          }
          value={filters['latest.student.size__range']}
        />
        <Box mt={2}>
          <Button
            fullWidth
            onClick={onReset}
            variant="contained"
            color="primary"
          >
            Reset Filters
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default Filters;
